export default __webpack_public_path__ + "static/media/victory-lg.de5230c9.png";